import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import shared subcomponents if you like
import styles from "./AccountManagement.module.css";
import ProfileForm from "../../components/ProfileForm";
import ConfirmationMessage from "../../components/ConfirmationMessage/ConfirmationMessage";
import GlacierPayment from "../../components/GlacierPayment/GlacierPayment";
import { StaticRoutes } from "../routes";
import PricingOption from "../../components/PricingOption/PricingOption";
import environment from "../../environment";
import ChangeSubscriptionModal from "../../components/ChangeSubscriptionModal";
import Loader from "../../components/Loader/Loader";
import { Auth } from "../../auth";

const AccountManagement = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  pricingOptions = [
    {
      packageName: "BidPro Bundle",
      priceMonthly: "26.99",
      priceAnnual: "323.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "",
            features: [],
          },
        },
        {
          section: {
            logo: "BidProPlusSeniorityLogo.png",
            header: "",
            features: [],
          },
        },
        {
          section: {
            logo: "BidProPlusTripBoardLogo.png",
            header: "Access to all the BidPro apps including:",
            features: [
              {
                feature: "Web-based Bidding",
                isNew: "",
              },
              {
                feature: "Seniority",
                isNew: "",
              },
              {
                feature: "Web-based TripBoard",
                isNew: "",
              },
              {
                feature: "iOS Mobile TripBoard",
                isNew: "NEW!*",
              },
            ],
          },
        },
      ],
      isBundle: true,
      savings: "10%",
      note: "Unlimited downloads for all your iOS devices included!",
    },
    {
      packageName: "Bidding & Seniority",
      priceMonthly: "9.99",
      priceAnnual: "119.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "Bidding",
            features: [
              {
                feature: "Download bid packages",
                isNew: "",
              },
              {
                feature: "Customize bidline colors & sorts",
                isNew: "",
              },
              {
                feature: "Search & prepare bids offline",
                isNew: "",
              },
              {
                feature: "Submit bids directly and skip PBSI",
                isNew: "",
              },
            ],
          },
        },
        {
          section: {
            logo: "BidProPlusSeniorityLogo.png",
            header: "Seniority",
            features: [
              {
                feature: "View Seniority Ranking on a detailed graph",
                isNew: "",
              },
              {
                feature: "Compare rankings to other fleets",
                isNew: "",
              },
              {
                feature: "View yearly retires and estimate seniority",
                isNew: "",
              },
              {
                feature: "Use offline",
                isNew: "",
              },
            ],
          },
        },
      ],
      isBundle: false,
      savings: "",
      note: "",
    },
    {
      packageName: "TripBoard",
      priceMonthly: "19.99",
      priceAnnual: "239.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusTripBoardLogo.png",
            header: "Web-based TripBoard",
            features: [
              {
                feature: "View Schedule",
                isNew: "",
              },
              {
                feature: "Post & pick up trips",
                isNew: "",
              },
              {
                feature: "Receive trip notifications via text or email",
                isNew: "",
              },
              {
                feature: "View estimated pay & credit",
                isNew: "",
              },
            ],
          },
        },
        {
          section: {
            logo: "",
            header: "IOS Mobile TripBoard",
            features: [
              {
                feature: "View Schedule",
                isNew: "",
              },
              {
                feature: "Post & pick up trips",
                isNew: "",
              },
              {
                feature: "Receive trip notifications via text or email",
                isNew: "",
              },
              {
                feature: "Sync your schedule to your device",
                isNew: "NEW!",
              },
            ],
          },
        },
      ],
      isBundle: false,
      savings: "",
      note: "",
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  const [currentStep, setCurrentStep] = useState("summary");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [animate, setAnimate] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const { billingName, billingCycle, billingPrice, subscriptionId } =
    location.state || {};
  const [isLoading, setIsLoading] = useState(true);
  const [didPayUpdateFail, setDidPayUpdateFail] = useState(false);

  const [isSubModalOpen, setOpenSubModalOpen] = useState(false);
  const [cancelSubError, setCancelSubError] = useState("");
  const [cancelSubLoading, setCancelSubLoading] = useState(false);
  const handleCloseSubModal = () => setOpenSubModalOpen(false);

  const [dateNumeric, setDateNumeric] = useState(null);
  const handleOpenCancelModal = () => {
    let cycleValue = selectedProduct?.cycle === "monthly" ? 1 : 12;
    setDateNumeric(cycleValue);
    setOpenSubModalOpen(true);
  };

  useEffect(() => {
    if (currentStep === "success") {
      navigate("/account");
    }
  }, [currentStep, navigate]);

  useEffect(() => {
    setAnimate(true);
  }, []);

  useEffect(() => {
    if (location.state?.step) {
      setCurrentStep(location.state.step);
    }
  }, [location.state]);

  useEffect(() => {
    if (selectedProduct && currentStep === "changeSubscription") {
      handleSubscriptionChange();
    }
  }, [selectedProduct, currentStep]);
  const productIdMap = {
    "Bidding & Seniority": {
      monthly: 1, // $9.99
      annual: 3, // $119.88
    },
    TripBoard: {
      monthly: 4, // $19.99
      annual: 5, // $239.88
    },
    "BidPro Bundle": {
      monthly: 6, // $26.99
      annual: 7, // $323.88
    },
  };

  const handleConfirmCancel = async (dateNumeric) => {
    setCancelSubLoading(true);
    setCancelSubError("");

    const newProductId =
      productIdMap[selectedProduct?.productName]?.[selectedProduct?.cycle];

    if (!subscriptionId || !newProductId) {
      setCancelSubLoading(false);
      setCancelSubError("Missing subscription or product selection.");
      return;
    }

    try {
      const response = await fetch(
        environment.apiBase + "/UserChangeSubscriptionPost",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            currentSubscriptionId: subscriptionId,
            // newProductId,
            billingCycle: dateNumeric,
            billingPrice: selectedProduct?.price,
          }),
        }
      );

      const msgBody = await response.json();

      if (!response.ok) {
        setCancelSubLoading(false);
        setCancelSubError(msgBody.message);
      } else {
        setCancelSubLoading(false);
        setOpenSubModalOpen(false);
        navigate("/account");
      }
    } catch (error) {
      setCancelSubLoading(false);
      setCancelSubError("Something went wrong.");
    }
  };

  const handleSubscriptionChange = async () => {
    try {
      let cycleValue = selectedProduct?.cycle === "monthly" ? 1 : 12;
      if (!cycleValue) {
        return;
      }

      setDateNumeric(cycleValue);
      setOpenSubModalOpen(true);
    } catch (error) {}
  };
  const attemptAccountUpdate = async (combinedData) => {
    try {
      const fetchResponse = await fetch(
        environment.apiBase + "/UserUpdatePaymentPost",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(combinedData),
          credentials: "include",
        }
      );

      const result = await fetchResponse.json();

      if (fetchResponse.ok) {
        return { success: true, result };
      } else {
        return { success: false, result };
      }
    } catch (error) {
      return { success: false, error };
    }
  };

  const handlePaymentUpdate = async (response) => {
    try {
      const combinedData = {
        paymentToken: response.token,
        zipcode: response.zip,
        cardFirstName: response.cardFirstName,
        cardLastName: response.cardLastName,
        productPrice: selectedProduct?.price,
        productCycle: selectedProduct?.cycle,
        currentSubscriptionId: subscriptionId,
      };

      if (
        !combinedData.paymentToken ||
        !combinedData.zipcode ||
        !combinedData.cardFirstName ||
        !combinedData.cardLastName ||
        !combinedData.currentSubscriptionId
      ) {
        setDidPayUpdateFail(true);
      }

      const { success, result } = await attemptAccountUpdate(combinedData);
      if (success) {
        setCurrentStep("success");
        return;
      } else {
        // setErrorMessage(
        //   `Update failed after ${maxRetries} attempts. Please contact support!`
        // );
        setDidPayUpdateFail(true);
      }

      //setCurrentStep("success");
    } catch (error) {}
  };

  const handleConfirmation = (productName, cycle) => {
    const selectedOption = pricingOptions.find(
      (option) => option.packageName === productName
    );

    if (!selectedOption) {
      return;
    }

    const logos = selectedOption.sections
      .map((s) => s.section.logo)
      .filter(Boolean);

    const price =
      cycle === "monthly"
        ? selectedOption.priceMonthly
        : selectedOption.priceAnnual;

    const features = selectedOption.sections.flatMap((s) =>
      s.section.features.map((f) => f.feature)
    );
    setSelectedProduct({
      productName,
      imageSrc: logos,
      price,
      features,
      cycle,
    });

    //setCurrentStep("profile"); // Move to profile form step SHOULD BE PROFILE
  };

  const handleProfileSave = async (data) => {
    if (!data || Object.keys(data).length === 0) {
      return;
    }

    if (data) {
      try {
        const response = await fetch(
          environment.apiBase + "/account/updateprofile",
          {
            method: "PUT",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const responseData = await response.json();
        navigate("/account", { state: { showPasswordSuccess: true } });

        //setProfileData(data);
      } catch (error) {
        //  setShowErrorComponent(true); // Show error component
      }
    }
    //setFormData(data);
  };

  useEffect(() => {
    if (currentStep === "updateProfile") {
      const fetchProfileData = async () => {
        setIsLoading(true);
        try {
          const response = await fetch(
            environment.apiBase + "/UserGetFormData",
            {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!response.ok) {
            throw new Error(
              `Error: ${response.status} - ${response.statusText}`
            );
          }

          const data = await response.json();
          setProfileData(data);
        } catch (error) {
          //  setShowErrorComponent(true); // Show error component
        } finally {
          setIsLoading(false);
        }
      };

      fetchProfileData();
    }
  }, [currentStep]);

  return (
    <div>
      {currentStep === "summary" && (
        <div>
          <button onClick={() => setCurrentStep("updateProfile")}>
            Edit Profile
          </button>
          <button onClick={() => setCurrentStep("changeSubscription")}>
            Change Subscription
          </button>
          <button onClick={() => setCurrentStep("payment")}>
            Update Card Info
          </button>
        </div>
      )}

      {currentStep === "updateProfile" &&
        (!isLoading ? (
          <div className={styles.profileFormContainer}>
            <div className={styles.h2}>
              <h2>Profile Information</h2>
            </div>
            <ProfileForm
              initialFirstName={profileData?.FirstName}
              initialLastName={profileData?.LastName}
              initialPosition={profileData?.PositionName}
              initialEquipment={profileData?.EquipmentName}
              initialBase={profileData?.BaseName}
              initialEmployeeNumber={profileData?.UserName}
              initialEmail={profileData?.Email}
              initialPhoneNumber={profileData?.PhoneNumber}
              initialPassword=""
              initialConfirmPassword=""
              profileEditable={true}
              isSignUp={false}
              onCancel={() => navigate("/account")}
              onSave={handleProfileSave}
              isPasswordReset={profileData?.IsResettingPassword}
            />
          </div>
        ) : (
          <div className={styles.loaderContainer}>
            <Loader color={"#3c4554"} size={75} />
          </div>
        ))}

      {/* FIX ME SYLING OFF */}
      {currentStep === "changeSubscription" && (
        <>
          <div className={styles.pricingContainer}>
            <div className={styles.header}>
              <h2 className={styles.subHeader}>Pricing</h2>
              <p>
                BidPro software products are offered as monthly or annual
                subscriptions. To view a more detailed product description,
                select Bidding, TripBoard, or Seniority from the PRODUCTS
                dropdown.
              </p>
            </div>
            <div
              className={`row ${animate ? styles.slideIn : ""}`}
              id={styles.options}
            >
              {pricingOptions.map((option, index) => {
                const isMonthly =
                  billingCycle == "1" && option.priceMonthly == billingPrice;

                const isAnnual =
                  billingCycle == "12" && option.priceAnnual == billingPrice;

                const selectedType = isMonthly
                  ? "monthly"
                  : isAnnual
                  ? "annual"
                  : null;

                return (
                  <div
                    className={`${styles.col} ${styles.selected}`}
                    key={index}
                  >
                    <PricingOption
                      {...option}
                      onMonthly={() =>
                        handleConfirmation(option.packageName, "monthly")
                      }
                      onAnnual={() =>
                        handleConfirmation(option.packageName, "annual")
                      }
                      currentSelected={selectedType}
                      //isSelected={isSelected}
                    />
                  </div>
                );
              })}
            </div>
            <div>
              <ChangeSubscriptionModal
                isOpen={isSubModalOpen}
                onCloseButtonClick={handleCloseSubModal}
                onConfirmCancel={() =>
                  cancelSubLoading ? null : handleConfirmCancel(dateNumeric)
                }
                billingCycle={dateNumeric}
                changeSubError={cancelSubError}
                isLoading={cancelSubLoading}
              />
            </div>
          </div>
        </>
      )}

      {currentStep === "confirmation" && (
        <ConfirmationMessage
          product={selectedProduct?.productName}
          // ...
          // onContinue={() => setCurrentStep("payment")}
          // onCancel={() => setCurrentStep("changeSubscription")}
        />
      )}

      {currentStep === "payment" && (
        <GlacierPayment
          product={selectedProduct?.productName}
          price={selectedProduct?.price}
          cycle={selectedProduct?.cycle}
          onSuccess={(response) => {
            handlePaymentUpdate(response);
          }}
          didFail={didPayUpdateFail}
          onCancel={() => navigate("/account")}
          errorMessage={didPayUpdateFail}
        />
      )}
    </div>
  );
};

export default AccountManagement;
